import {Loader} from '@mantine/core';
import Image from 'next/image';
import {IoMdVideocam} from 'react-icons/io';
import {IoAlertCircle, IoPlayCircleOutline} from 'react-icons/io5';
import {MdOutlineSlideshow} from 'react-icons/md';
import {isReleasedRedesignRecruitment} from '../../../../config/unReleasePage';
import {useGetRecruitmentWebSeminars} from '../../../../core/repositories/recruitmentRepository';
import {CommonLink} from '../../../../shared/components/CommonLink';
import {useMediaQuery} from '../../../../shared/services/useMediaQuery';
import {CompanyWebSeminar} from '../../../company/components/Container/Presenter/CompanyWebSeminar';

type Props = {
  companyId: number;
  companyName?: string;
};

export const WebSeminarList: React.FC<Props> = ({companyId, companyName}) => {
  const {isPC} = useMediaQuery();
  const {data, isLoading} = useGetRecruitmentWebSeminars({
    companyId,
    limit: 3,
  });

  if (isReleasedRedesignRecruitment()) {
    // 新デザイン：CompanyWebSeminarを使う
    if (data?.ok && data.value.length > 0) {
      return (
        <div>
          <div className="bg-white p-16 rounded-t-16 mt-16">
            <h2 className="font-bold">動画</h2>
          </div>
          <div className="flex flex-col pc:flex-row pc:justify-between mt-8 gap-8">
            {data.value.map((seminar) => (
              <CompanyWebSeminar
                key={seminar.id}
                webSeminarID={seminar.id}
                webSeminarThumbnailURL={seminar.thumbnailURL}
                webSeminarTitle={seminar.title}
                companyName={companyName}
                description={seminar.description}
                isOriginal={seminar.isOriginal}
                isFreeListing={seminar.isFreeListing}
                isPrMovie={seminar.isPrMovie}
                widthClass={'pc:w-[50%]'}
              />
            ))}
          </div>
        </div>
      );
    }
    return null;
  }

  return isLoading ? (
    <div className="w-full h-[150px] flex justify-center items-center">
      <Loader color="gray" />
    </div>
  ) : (
    data?.ok &&
      data.value.length > 0 &&
      data.value.map((seminar) => (
        <div className="bg-black-5 p-16 mt-16 w-full">
          <p className="font-bold mb-12">
            <CommonLink
              href={`/web_seminars/view/${seminar.id}`}
              className="hover:underline text-link line-clamp-2 pc:line-clamp-none"
            >
              {seminar.title}
            </CommonLink>
          </p>
          <div className="flex flex-col pc:flex-row pc:justify-between">
            <div className="w-[295px] pc:w-[311px] pc:h-[174px] relative mx-auto">
              <Image
                src={seminar.thumbnailURL}
                className="object-cover w-full h-full block"
                alt={seminar.title}
                width={isPC ? 311 : 295}
                height={isPC ? 174 : 166}
              />
              <div className="absolute top-0 left-0 w-full h-full bg-overlay-1 opacity-40" />
              <ul className="absolute top-0 left-0">
                {seminar.isOriginal && (
                  <li className="bg-notification-1 text-white px-8 py-auto text-sm leading-5 my-4">
                    <IoAlertCircle
                      className="inline-block text-white"
                      size={20}
                    />
                    独占映像
                  </li>
                )}
                {seminar.isFreeListing && (
                  <li className="bg-white text-notification-1 px-8 py-auto text-sm leading-5 my-4">
                    <IoPlayCircleOutline
                      className="inline-block text-notification-1"
                      size={20}
                    />
                    YouTube
                  </li>
                )}
                {seminar.isPrMovie ? (
                  <li className="bg-white text-primary-1 px-8 py-auto text-sm leading-5 my-4">
                    <IoMdVideocam
                      className="inline-block text-primary-1"
                      size={20}
                    />
                    企業PV
                  </li>
                ) : (
                  <li className="bg-white text-primary-1 px-8 py-auto text-sm leading-5 my-4">
                    <MdOutlineSlideshow
                      className="inline-block text-primary-1"
                      size={20}
                    />
                    プレゼン
                  </li>
                )}
              </ul>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pc:w-[140px] pc:h-[48px]">
                <CommonLink
                  className="block pc:max-w-none text-link text-center py-12 px-12 border-solid border-link border-2 rounded bg-white pc:hover:opacity-80"
                  href={`/web_seminars/view/${seminar.id}`}
                >
                  説明を聞く
                </CommonLink>
              </div>
            </div>
            <div className="text-black-2 w-full pc:w-[calc(100%-333px)] overflow-hidden pc:ml-12 pt-12 pc:pt-0">
              <p className="w-full line-clamp-2 pc:line-clamp-[9] text-sm pc:text-base">
                {seminar.description}
              </p>
            </div>
          </div>
        </div>
      ))
  );
};
